var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.195 45.458"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".check-circle_inline_svg__a{fill:none;stroke:#2261da;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.3px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "check-circle_inline_svg__a",
    d: "M43.754 20.781v1.958A21.051 21.051 0 1131.273 3.498"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "check-circle_inline_svg__a",
    d: "M45.861 3.793L22.705 26.949l-6.315-6.315"
  })));
}

export default SvgCheckCircleinline;